import React from 'react';
import { WHATSAPP_URL } from '../utils/whatsapp';

const footerLinks = ['The work', 'Our story', 'Experience', 'Journal', 'Kind words'];

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <div className="wordmark footer-wordmark">
            still <span>&</span> story.
            <small>PHOTOGRAPHY STUDIO</small>
          </div>
          <p>Photographs for the parts you never want to forget.</p>
        </div>
        <div className="footer-links">
          {footerLinks.map((label) => (
            <a key={label} href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">{label}</a>
          ))}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">WhatsApp us ↗</a>
        </div>
      </div>
      <div className="footer-meta">
        <span>© {new Date().getFullYear()} Still & Story Studio</span>
        <span>Made with love, for love.</span>
        <button className="back-to-top" type="button" onClick={scrollToTop}>Back to top ↑</button>
      </div>
    </footer>
  );
}

export default Footer;
